/******************************************************************************
 *
 * ExecutionProgress
 *
 * Displays execution progress of the selected Work Item.
 *
 ******************************************************************************/

import React from "react";

export default function ExecutionProgress({

    workItem,

    checklists = []

}) {

    const progress =
        workItem?.completion_percentage || 0;

    const progressColor =
        progress === 100
            ? "#16A34A"
            : progress > 0
            ? "#2563EB"
            : "#9CA3AF";

    const statusColor = {

        OPEN: "#6B7280",

        IN_PROGRESS: "#2563EB",

        COMPLETED: "#16A34A",

        CANCELLED: "#DC2626"

    }[workItem?.status] || "#6B7280";

    return (

        <div
            className="card border-0 shadow-sm mb-3"
            style={{
                borderRadius: "12px"
            }}
        >

            {/* Header */}

            <div
                className="card-header border-0 text-white py-2"
                style={{
                    background:
                        "linear-gradient(135deg,#2563EB,#1E40AF)",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px"
                }}
            >

                <div className="fw-semibold">

                    📈 Execution Progress

                </div>

            </div>

            <div className="card-body py-3">

                {/* Progress */}

                <div className="d-flex justify-content-between align-items-center mb-2">

                    <span
                        className="fw-semibold"
                        style={{
                            fontSize: "14px"
                        }}
                    >
                        Overall Progress
                    </span>

                    <span
                        className="fw-bold"
                        style={{
                            color: progressColor
                        }}
                    >
                        {progress}%
                    </span>

                </div>

                <div
                    className="progress"
                    style={{
                        height: "10px",
                        borderRadius: "10px",
                        background: "#E5E7EB"
                    }}
                >

                    <div
                        className="progress-bar"
                        style={{
                            width: `${progress}%`,
                            background: progressColor,
                            borderRadius: "10px"
                        }}
                    />

                </div>

                {/* Summary */}

                <div className="row text-center mt-3">

                    <div className="col-4">

                        <div
                            className="fw-bold"
                            style={{
                                fontSize: "20px"
                            }}
                        >
                            {checklists.length}
                        </div>

                        <small className="text-muted">

                            Checklists

                        </small>

                    </div>

                    <div className="col-4">

                        <span
                            className="badge"
                            style={{
                                background: statusColor,
                                fontSize: "12px"
                            }}
                        >
                            {workItem?.status || "-"}
                        </span>

                        <div>

                            <small className="text-muted">

                                Status

                            </small>

                        </div>

                    </div>

                    <div className="col-4">

                        <div
                            className="fw-bold"
                            style={{
                                fontSize: "20px"
                            }}
                        >
                            {workItem?.estimated_hours || 0}
                        </div>

                        <small className="text-muted">

                            Hours

                        </small>

                    </div>

                </div>

            </div>

        </div>

    );

}